module.exports = __webpack_public_path__ + "a7a790d499af8d37b9f742a666ab849c.ttf";